import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import LegacyDropdownMenu from 'ui-library/dropdowns/LegacyDropdownMenu';
import LegacyDropdownMenuItem from 'ui-library/dropdowns/LegacyDropdownMenuConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

interface ExportDropdownProps {
  buttonStyle?: ButtonStyle;
  disabled?: boolean;
  menuItems: Array<Array<LegacyDropdownMenuItem>>;
  // Renders old Bootstrap caret if true, otherwise uses new dropdown button style.
  useCaret?: boolean;
  tooltipTitleWhenDisabled?: string;
}

export default function ExportDropdown({
  buttonStyle = ButtonStyle.TERTIARY_WHITE,
  disabled = false,
  menuItems,
  useCaret = false,
  tooltipTitleWhenDisabled,
}: ExportDropdownProps): JSX.Element | null {
  return (
    <Tooltip
      container="body"
      placement={TooltipPlacement.TOP}
      title={disabled ? tooltipTitleWhenDisabled : 'Export'}
      disabled={disabled && tooltipTitleWhenDisabled == null}
    >
      <div className="buttonGroup">
        {useCaret ? (
          <button
            className={`button button--${buttonStyle} button--small dropdown-toggle`}
            data-toggle="dropdown"
            disabled={disabled}
            type="button"
          >
            <BenchlingIcon icon="export" />
            <span className="caret" />
          </button>
        ) : (
          <Button
            aria-label="Export"
            buttonStyle={buttonStyle}
            disabled={disabled}
            icon="export"
            isDropdown={true}
            size={ButtonSize.SMALL}
            dataTestAttrs={{component: 'ExportDropdown', element: 'button'}}
          />
        )}
        <LegacyDropdownMenu
          className="dropdown-menu--dropLeft"
          dataTestAttrs={{component: 'ExportDropdown', element: 'menu'}}
          items={menuItems}
          expandToFit={true}
        />
      </div>
    </Tooltip>
  );
}
